import { Popover, PopoverContent, PopoverTrigger } from '@ibsys/kit';
import { CircleAlertIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui';
import { PASSWORD_MIN_LENGTH, PASSWORD_SPECIAL_CHARACTERS } from '../../model/passwordRules';

/**
 * Значок (!) для подписи поля нового пароля: по нажатию — подсказка с требованиями к паролю.
 * В подсказке только требования к составу пароля; о прочих правилах сообщает отказ у поля.
 */
export const PasswordRulesHint: FC = () => {
  const { t } = useTranslation('common');

  const requirements = [
    t('passwordRules.hint.minLength', { length: PASSWORD_MIN_LENGTH }),
    t('passwordRules.hint.uppercase'),
    t('passwordRules.hint.lowercase'),
    t('passwordRules.hint.digit'),
    t('passwordRules.hint.specialCharacter', { characters: Array.from(PASSWORD_SPECIAL_CHARACTERS).join(' ') }),
  ];

  return (
    <Popover>
      <IconButton
        size="icon"
        className="size-5"
        label={t('passwordRules.hint.open')}
        icon={<CircleAlertIcon className="size-3.5 text-muted-foreground" />}
        trigger={PopoverTrigger}
      />
      <PopoverContent className="w-72 p-3" align="start">
        <div className="flex flex-col gap-2 text-sm">
          <span className="font-medium">{t('passwordRules.hint.title')}</span>
          <ul className="flex list-disc flex-col gap-1 pl-4">
            {requirements.map((requirement) => (
              <li key={requirement}>{requirement}</li>
            ))}
          </ul>
        </div>
      </PopoverContent>
    </Popover>
  );
};
